<template>
  <learning-center-feedback-form form-type="feedback" />
</template>

<script>
import LearningCenterFeedbackForm from './learningCenterFeedbackForm.vue';

export default {
  name: 'LearningCenterFeedbackTab',
  components: {
    LearningCenterFeedbackForm,
  },
};
</script>


